<ngx-spinner [fullScreen]="false" bdColor="rgba(0,0,0,0.2)" type="ball-spin" size="default"> </ngx-spinner>
<div mat-dialog-title align="end">
    <button mat-icon-button [mat-dialog-close]>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <div fxLayout="column" fxLayoutGap="5px">
        <img *ngFor="let img of certificate?.images" [src]="img.url" alt="certificate_image" class="image" />
    </div>
    <iframe
        *ngIf="certificate && (!certificate?.images || certificate?.images.length == 0)"
        [src]="certificate.pdfUrl | safe"
        frameborder="0"
        style="overflow: hidden; height: 67dvh; min-width: 80vw; max-width: 99vw"
        height="100%"
        width="100%"
    >
    </iframe>
</mat-dialog-content>
<mat-card-actions fxLayout="row wrap" fxLayoutAlign="end end" fxLayoutGap="10px" style="margin-top: 10px; height: 50px">
    <button id="share" mat-button color="primary" *ngIf="certificate?.images?.length > 0" (click)="share()">
        <mat-icon>share</mat-icon>
        {{ "CERTIFICATE_VIEWER.SHARE.LABEL" | translate }}
    </button>
    <button id="download" mat-raised-button color="primary" (click)="download()">
        <mat-icon>download</mat-icon>
        {{ "CERTIFICATE_VIEWER.DOWNLOAD" | translate }}
    </button>
</mat-card-actions>
